// extracted by mini-css-extract-plugin
export default {"headerContainer":"listChats_headerContainer__C+CUx","header":"listChats_header__OI6vo","chatsContainer":"listChats_chatsContainer__AHxuO"};